/**
 * 避免用户快速输入时保存显示渲染频繁
 * 降低渲染频率 提升性能
*/
import {rteNotifyPublishTypeAction} from '@/constants/document/notification';
import {INotify} from '@/types/document/notification';

const DEBOUNCE_TIME = 800;
let cache: any[] = [];
let timer: NodeJS.Timeout | null = null;

function reset() {
    timer && clearTimeout(timer);
    cache = [];
    timer = null;
}
export const saveDebounce = (action: INotify['action'], callback: any) => {
    const executeCallback = () => {
        reset();
        callback && callback();
    };
    if (action === rteNotifyPublishTypeAction.SAVING) {
        executeCallback();
        timer = setTimeout(() => {
            const lastSuccessCallBack = cache.pop();
            reset();
            lastSuccessCallBack && lastSuccessCallBack();
        }, DEBOUNCE_TIME);
        return;
    }
    if (action === rteNotifyPublishTypeAction.SUCCESS) {
        if (timer) {
            cache.push(() => {
                executeCallback();
            });
            return;
        }
        executeCallback();
        return;
    }
    executeCallback();
};
